// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"c04577df","172":"808e803a","174":"0dd771a5","293":"0624ef0a","357":"9a48d470","478":"56a3aa37","486":"97feca49","551":"56a3aa37","765":"ebabaf04"}[chunkId] + ".chunk.css";
};